import React, { useEffect, useState, useMemo, useRef } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";

import Chip from "@mui/material/Chip";

import { DataGrid } from "@mui/x-data-grid";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/ro";
dayjs.locale("ro");

dayjs.extend(utc);
dayjs.extend(timezone);

import IconButton from "@mui/material/IconButton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

import axios from "axios";
import _ from "lodash";
import debounce from "lodash.debounce";

import Header from "./components/header";
import ViewDialog from "./components/ViewDialog";
import EditDialog from "./components/EditDialog";

function getDate(params) {
  return dayjs(params.row.start_time).format("DD.MM.YY");
  //   return `${params.row.p_name || ""} `;
}

const initialState = {
  service_type: "",
  doctor: null,
  status: "",
  date: null,
  filter: "",
};

let status_options = [
  { id: "created", label: "Created", color: "disabled" },
  { id: "confirmed", label: "Confirmed", color: "primary" },
  { id: "completed", label: "Completed", color: "success" },
  { id: "canceled", label: "Canceled", color: "error" },
];

let service_options = [
  { id: "Reumatologie", label: "Reumatologie" },
  { id: "Recuperare Medicala", label: "Recuperare Medicala" },
];

function getStatusColor(value) {
  const filtered = status_options.filter((status) => {
    return status.id === value;
  });
  //   console.log(filtered[0].color);
  if (filtered[0]) return filtered[0].color;
  return "disabled";
}

function Dashboard() {
  //   const [service, setService] = useState("");
  //   const [doctor, setDoctor] = useState(null);
  //   const [status, setStatus] = useState("created");
  //   const [date, setDate] = useState(null);

  const [state, setState] = useState(initialState);

  const [docApi, setDocApi] = useState([]);
  const [appApi, setAppApi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [selected, setSelected] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [edited, setEdited] = React.useState(false);
  const [query, setQuery] = React.useState({
    sort: "start_time",
    order: 1,
  });

  const inputRef = useRef(null);

  function prepareQuery(query) {
    var str = "";
    for (var key in query) {
      if (str != "") {
        str += "&";
      }
      str += key + "=" + encodeURIComponent(query[key]);
    }

    return str;
  }

  const updateAppApi = async (item) => {
    const response = await axios.patch(
      process.env.REACT_APP_API_URL + `/appointment/` + item._id,
      item
    );
    // console.log("delete app", response);
  };

  const deleteAppApi = async (id) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + `/appointment/` + id
    );
    // console.log("delete app", response);
  };

  const getDocApi = async () => {
    // console.log("axios ", axios.defaults.headers);
    const { data } = await axios.get(
      process.env.REACT_APP_API_URL + `/doctors?limit=100`
    );
    // console.log("doclist", data.docs);
    setDocApi(data.docs);
  };

  const getAppApi = async (q, p) => {
    let pret_page = { page: p + 1 };
    let prep_query = prepareQuery({ ...q, ...pret_page });
    console.log("api_query", q, prep_query);

    try {
      const { data } = await axios.get(
        process.env.REACT_APP_API_URL + `/appointment?` + prep_query
      );

      // console.log(data.docs);

      setAppApi(data.docs);
      setTotal(data.totalDocs);
      setLoading(false);
    } catch (err) {
      console.log(err.response.status);
    }
  };

  useEffect(() => {
    setLoading(true);
    getAppApi(query, page);
  }, [page, query]);

  useEffect(() => {
    getDocApi();
    // getAppApi();
    return () => {
      debouncedEventHandler.cancel();
    };
  }, []);

  useEffect(() => {
    if (state.filter === "" || state.filter.length > 2) {
      let q = {
        sort: "start_time",
        order: 1,
      };
      // console.log("refresh data", state);
      if (state.service_type !== "") q.service_type = state.service_type;
      if (state.doctor != null) q.doctor = state.doctor._id;
      if (state.status !== "") q.status = state.status;
      if (state.date != null) q.date = state.date;
      if (state.filter.length > 2) q.filter = state.filter;

      //   getAppApi(q);

      setQuery(q);
      setPage(0);
    }
  }, [state]);

  const handleDeleteClick = (e, item) => {
    e.stopPropagation();
    // console.log(item);
    if (window.confirm("Do you really want to delete this appointment?")) {
      setAppApi(appApi.filter((row) => row._id !== item._id));
      deleteAppApi(item._id);
    }
  };

  const handleViewDelete = (item) => {
    // console.log("delete", item);

    if (window.confirm("Do you really want to delete this appointment?")) {
      setAppApi(appApi.filter((row) => row._id !== item._id));
      deleteAppApi(item._id);
      setOpen(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // console.log(name, value);

    setState({
      ...state,
      [name]: value,
    });
  };

  const debouncedEventHandler = useMemo(
    () => debounce(handleChange, 300),
    [state]
  );

  const handleViewOpen = (e, row) => {
    e.stopPropagation();
    // console.log(row);
    setSelected(row);
    setOpen(true);
  };

  const handleViewClose = () => {
    setOpen(false);
    setSelected(null);
  };

  const handleEditOpen = (e, row) => {
    e.stopPropagation();
    // console.log(row);
    setEdited(row);
    setEdit(true);
  };
  const handleEditClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      // console.log(reason);
    } else {
      setEdit(false);
      setEdited(null);
    }
  };

  const handleEditChange = ({ target: { name, value } }) => {
    // console.log("edit_change", name, value);

    if (name === "start_time") {
      let new_end_time = dayjs(value)
        .hour(dayjs(edited.end_time).hour())
        .minute(dayjs(edited.end_time).minute());
      setEdited({
        ...edited,
        [name]: value,
        end_time: new_end_time,
      });
    } else {
      setEdited({
        ...edited,
        [name]: value,
      });
    }
  };

  const handleEditSave = () => {
    // console.log("edit_save_action");

    const newState = appApi.map((obj) => {
      // 👇️ if id equals 2, update country property
      if (obj._id === edited._id) {
        return { ...obj, ...edited };
      }

      // 👇️ otherwise return object as is
      return obj;
    });

    setAppApi(newState);
    updateAppApi(edited);
    setEdit(false);
    setEdited(null);
  };
  const handleBackdropClick = () => {
    //these fail to keep the modal open
    event.stopPropagation();
    return false;
  };

  return (
    <>
      <Header></Header>
      <Container maxWidth="xl">
        <ViewDialog
          open={open}
          selected={selected}
          onClose={handleViewClose}
          onDelete={handleViewDelete}
        ></ViewDialog>
        <EditDialog
          open={edit}
          onBackdropClick={handleBackdropClick}
          disableEscapeKeyDown
          edited={edited}
          onClose={handleEditClose}
          onSave={handleEditSave}
          onEditChange={handleEditChange}
          serviceOpt={service_options}
          statusOpt={status_options}
          doctorOpt={docApi}
        ></EditDialog>
        <Typography variant="h6" sx={{ mt: 4 }}>
          Filtrare
        </Typography>
        <Paper elevation={3} sx={{ mt: 1, p: 2 }}>
          <Grid
            container
            alignItems="center"
            direction="row"
            justifyContent="space-between"
          >
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  select
                  size="small"
                  label="Service"
                  name="service_type"
                  id="demo-simple-select-filled"
                  value={state.service_type}
                  onChange={handleChange}
                >
                  <MenuItem value="Reumatologie">Reumatologie</MenuItem>
                  <MenuItem value="Recuperare Medicala">
                    Recuperare Medicala
                  </MenuItem>
                </TextField>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <Autocomplete
                  disablePortal
                  value={state.doctor}
                  id="doctor"
                  size="small"
                  name="doctor"
                  options={docApi}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  getOptionLabel={(option) => option.name || ""}
                  onChange={(event, newValues) => {
                    // console.log(newValues);
                    setState({
                      ...state,
                      doctor: newValues,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Doctor" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  select
                  size="small"
                  name="status"
                  label="Status"
                  id="demo-simple-select-filled"
                  value={state.status}
                  onChange={handleChange}
                >
                  <MenuItem value="created">Created</MenuItem>
                  <MenuItem value="confirmed">Confirmed</MenuItem>
                  <MenuItem value="completed">Completed</MenuItem>
                  <MenuItem value="canceled">Canceled</MenuItem>
                </TextField>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="ro"
                >
                  <DatePicker
                    label="Date"
                    name="date"
                    value={state.date}
                    onChange={(newValue) => {
                      console.log(newValue);
                      // console.log();
                      setState({
                        ...state,
                        date: dayjs(newValue).format("YYYY-MM-DD"),
                      });
                    }}
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mr: 1, width: "calc(100% - 8px)" }}>
                <TextField
                  fullWidth
                  size="small"
                  name="filter"
                  label="Search"
                  id="search"
                  inputRef={inputRef}
                  //   value={state.filter}
                  onChange={debouncedEventHandler}
                ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={1}>
              <Button
                variant="contained"
                size="small"
                disabled={_.isEqual(initialState, state)}
                sx={{ minHeight: "38px" }}
                onClick={() => {
                  setPage(0);
                  setState(initialState);
                  inputRef.current.value = "";
                  // console.log(inputRef.current.value);
                }}
              >
                reset
              </Button>
            </Grid>
          </Grid>
        </Paper>

        <div style={{ height: 600, width: "100%" }}>
          <div style={{ display: "flex", height: "100%" }}>
            <div style={{ marginTop: 16, flexGrow: 1 }}>
              <DataGrid
                loading={loading}
                pageSize={10}
                rowsPerPageOptions={[10]}
                rowCount={total}
                paginationMode="server"
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                disableColumnFilter={true}
                disableColumnMenu={true}
                disableColumnSelector={true}
                editMode="row"
                getRowId={(row) => row._id}
                sx={{
                  "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                    outline: "none !important",
                  },
                }}
                columns={[
                  {
                    field: "service_type",
                    headerName: "Service",
                    flex: 1,
                    sortable: false,
                  },
                  {
                    field: "doctor",
                    headerName: "Doctor",
                    flex: 1.5,
                    sortable: false,
                    renderCell: (params) => {
                      return params.value.name;
                    },
                  },
                  {
                    field: "p_name",
                    headerName: "Nume",
                    flex: 1,
                    sortable: false,
                  },
                  {
                    field: "p_email",
                    headerName: "Email",
                    flex: 1,
                    sortable: false,
                  },
                  {
                    field: "p_phone",
                    headerName: "Telefon",
                    flex: 1,
                    sortable: false,
                  },

                  {
                    field: "service_date",
                    headerName: "Date",
                    valueGetter: getDate,
                    flex: 0.5,
                    sortable: false,
                  },

                  {
                    field: "start_time",
                    headerName: "Start",
                    valueFormatter: (params) =>
                      dayjs(params?.value)
                        .tz("Europe/Bucharest")
                        .format(" HH:mm"),
                    sortable: false,
                  },
                  {
                    field: "end_time",
                    headerName: "End",
                    valueFormatter: (params) =>
                      dayjs(params?.value)
                        .tz("Europe/Bucharest")
                        .format(" HH:mm"),
                    sortable: false,
                  },
                  {
                    field: "status",
                    headerName: "Status",
                    sortable: false,
                    renderCell: (params) => {
                      if (params.value === "created") {
                        return <Chip label={params.value} size="small" />;
                      }

                      return (
                        <Chip
                          label={params.value}
                          size="small"
                          color={getStatusColor(params.value)}
                        />
                      );
                    },
                  },
                  {
                    field: "actions",
                    headerName: "Actions",
                    width: 120,
                    type: "actions",
                    renderCell: (params) => {
                      return (
                        <>
                          <IconButton
                            aria-label="view"
                            size="small"
                            onClick={(e) => handleViewOpen(e, params.row)}
                          >
                            <RemoveRedEyeIcon />
                          </IconButton>
                          <IconButton
                            aria-label="edit"
                            size="small"
                            onClick={(e) => handleEditOpen(e, params.row)}
                          >
                            <ModeEditIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            size="small"
                            color="error"
                            onClick={(e) => handleDeleteClick(e, params.row)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </>
                      );
                    },
                  },
                ]}
                rows={appApi}
              />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
export default Dashboard;
